import { ROOT_DOMAIN } from '../api';

const RESERVED_SUBDOMAINS = [
  'www', 'api', 'admin', 'mail', 'ftp', 'smtp', 'pop', 'imap',
  'ns1', 'ns2', 'ns3', 'dns', 'dns1', 'dns2',
  'cdn', 'static', 'assets', 'media', 'images', 'img',
  'app', 'dev', 'staging', 'preview', 'test', 'beta', 'demo',
  'shop', 'store', 'merch', 'tienda',
  'blog', 'news', 'help', 'support', 'docs',
  'dashboard', 'panel', 'manage', 'portal',
  'status', 'monitor', 'health',
  'vpn', 'proxy', 'gateway', 'lb', 'loadbalancer',
  'db', 'database', 'redis', 'pgbouncer', 'postgres',
  'docker', 'registry', 'k8s', 'kubernetes',
  'grafana', 'prometheus', 'kibana', 'elasticsearch',
  'jenkins', 'ci', 'cd', 'gitlab', 'github',
  'analytics', 'tracking', 'metrics',
  'payment', 'pay', 'checkout', 'billing',
  'auth', 'login', 'sso', 'oauth', 'jwt',
  'websocket', 'ws', 'wss', 'socket',
  'mx', 'mx1', 'mx2', 'webmail', 'email',
  'calendar', 'cal', 'meet', 'zoom',
  'video', 'stream', 'tv', 'live',
  'api2', 'v1', 'v2', 'v3', 'graphql', 'rest',
  'backend', 'frontend', 'web', 'mobile',
  'internal', 'private', 'secret', 'hidden',
  'files', 'download', 'uploads', 'backup',
  'logs', 'log', 'audit', 'trace',
  'cache', 'memcache', 'varnish',
  'search', 'index', 'query',
  'queue', 'mq', 'rabbitmq', 'kafka',
  'worker', 'scheduler', 'cron', 'job',
  'auth0', 'firebase', 'supabase',
  'vercel', 'netlify', 'heroku', 'render',
  'aws', 'azure', 'gcp', 'cloudflare',
  'localhost', 'local', 'devlocalhost', 'intranet',
  'mx', 'autodiscover', 'autoconfig',
  'cpanel', 'whm', 'webdisk',
  'plesk', 'ispconfig', 'directadmin',
  'miskipop',
];

export function getSubdomainFromHostname(hostname = window.location.hostname) {
  if (!hostname) return null;

  const host = hostname.toLowerCase().trim();

  if (host === ROOT_DOMAIN || host === `www.${ROOT_DOMAIN}`) {
    return null;
  }

  if (host.endsWith(`.${ROOT_DOMAIN}`)) {
    const subdomain = host.slice(0, -(ROOT_DOMAIN.length + 1));

    if (subdomain && !subdomain.includes('.') && !RESERVED_SUBDOMAINS.includes(subdomain)) {
      return subdomain;
    }
  }

  return null;
}

export function isSubdomain(hostname = window.location.hostname) {
  return getSubdomainFromHostname(hostname) !== null;
}
